"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFontFamilyFromFontMap = exports.getNumericPartFromVariant = exports.getFontFamilyName = exports.getFontFileName = exports.epubFontBaseUrl = void 0;
const misc_1 = require("../misc");
const getFontVariant_1 = require("./getFontVariant");
exports.epubFontBaseUrl = "fonts";
const getFontFileName = (font, variant) => {
    const extension = font.fontType ? font.fontType : "ttf";
    return `${font.id}-${(0, misc_1.capitalizeFirstLetter)(variant)}.${extension}`;
};
exports.getFontFileName = getFontFileName;
const getFontFamilyName = (fontId, variant) => {
    return `${fontId}${(0, misc_1.capitalizeFirstLetter)(variant)}`;
};
exports.getFontFamilyName = getFontFamilyName;
const getNumericPartFromVariant = (variant) => {
    const numericPart = variant.match(/\d+/); // Match one or more digits
    return numericPart ? parseInt(numericPart[0]) : null;
};
exports.getNumericPartFromVariant = getNumericPartFromVariant;
// export const getFontFileNameForEpubGen = (fontId: string, style: HeaderFontStyle[]): string => {
//   let font = find(fonts, {id: fontId});
//   if(!font){
//     font = fonts[0];
//   } 
//   let fontVariant = headerStyleToFontVariant(style);
//   if(!font.variants.includes(fontVariant)){
//     fontVariant = FontVariant.regular;
//   }
//   return getFontFileName(font, fontVariant);
// }
const getFontFamilyFromFontMap = (themeStyleProps, fontMap) => {
    const headerFontConfig = {
        chapterTitleFont: {
            fontId: themeStyleProps.chapterTitle.font,
            fontVariant: (0, getFontVariant_1.headerStyleToFontVariant)(themeStyleProps.chapterTitle.style)
        },
        chapterSubtitleFont: {
            fontId: themeStyleProps.chapterSubtitle.font,
            fontVariant: (0, getFontVariant_1.headerStyleToFontVariant)(themeStyleProps.chapterSubtitle.style)
        },
        chapterNumberFont: {
            fontId: themeStyleProps.chapterNo.font,
            fontVariant: (0, getFontVariant_1.headerStyleToFontVariant)(themeStyleProps.chapterNo.style)
        }
    };
    switch (fontMap) {
        case "chapterTitle": return (0, exports.getFontFamilyName)(headerFontConfig.chapterTitleFont.fontId, headerFontConfig.chapterTitleFont.fontVariant);
        case "chapterSubtitle": return (0, exports.getFontFamilyName)(headerFontConfig.chapterSubtitleFont.fontId, headerFontConfig.chapterSubtitleFont.fontVariant);
        default: return (0, exports.getFontFamilyName)(headerFontConfig.chapterNumberFont.fontId, headerFontConfig.chapterNumberFont.fontVariant);
    }
};
exports.getFontFamilyFromFontMap = getFontFamilyFromFontMap;
